import {bindable, customElement, inject} from "aurelia-framework";
import {WorkflowService} from "../../workflow/workflow-service";

import "./bwa.less";
import {FlashService} from "../../flash/flash-service";
import {I18N} from 'aurelia-i18n';

@inject(WorkflowService, FlashService, I18N)
@customElement('sio-accounting-bwa')
export class Bwa {
    /** @type{Form} */
    form;
    /** @type{WorkflowService} */
    workflowService;

    @bindable() bwa;
    @bindable positions = null;

    pdfConfig = {
        label: 'action.pdf-download',
        buttonClass: 'tw-btn-primary'
    }
    excelConfig = {
        label: 'action.excel-download',
        buttonClass: 'tw-btn-primary'
    }
    submitConfig = {
        label: 'action.show',
        buttonClass: 'tw-btn-primary'
    }

    /**
     * @param {WorkflowService} workflowService
     * @param {FlashService} flash
     * @param i18n
     */
    constructor(workflowService, flash, i18n) {
        this.workflowService = workflowService;
        this.flash = flash;
        this.submit = this.submit.bind(this);
        this.i18n = i18n;
    }

    async bind() {
        this.positions = null;
        this.title = 'BWA-Position';
        this.headers = null;
    }

    submit(type) {
        const formValue = this.form.formService.getValue();

        if ('print' === type && 12 < (formValue.previousYear ? 2 : 1) * formValue.months.length) {
            this.flash.warning('Zu viele Monate für PDF-Bericht ausgewählt');
            return;
        }

        this.excelConfig.diabled = this.pdfConfig.disabled = this.submitConfig.disabled = true;
        this.data = null;
        this.dummyDataForTable = [];
        return this.workflowService
            .trigger(`accounting/generate-bwa${type ? "-" + type : ""}`, [this.bwa], formValue)
            .then(data => {
                this.data = data[0].bwa;

                this.writeCompareColumns();

                if (data[0].url) {
                    window.location.href = data[0].url;
                }

                for (const [key, value] of Object.entries(this.data.items)) {
                    console.log(`${key}: ${value}`);
                    this.dummyDataForTable.push({...value, mainId: key})
                    value.positions?.map(position => {
                        // value.title.replace(/[.,/\s]/g, '')
                        this.dummyDataForTable.push({...position, id: key})
                    })
                }

                return this.dummyDataForTable;
            }).finally(() => {
                this.excelConfig.diabled = this.pdfConfig.disabled = this.submitConfig.disabled = false;
            })
    }

    open(title, btnIndex) {
        let id = title.mainId
        var elms = document.querySelectorAll(`[id='${id}']`);
        var theButton = document.getElementById(btnIndex);
        if (theButton.getAttribute("aria-expanded") === "false") {

            for (var i = 0; i < elms.length; i++) {
                elms[i].classList.add('visible');
                elms[i].classList.remove('hiderow');

            }
            theButton.setAttribute("aria-expanded", "true");
        } else {
            for (var i = 0; i < elms.length; i++) {
                elms[i].classList.add('hiderow');
                elms[i].classList.remove('visible');
            }
            theButton.setAttribute("aria-expanded", "false");
        }
    }

    writeCompareColumns() {
        const endDateStr = this.data.query.period.endDate;
        const endDate = new Date(endDateStr);

        const currentYear = endDate.getFullYear();
        const previousYear = currentYear - 1;

        const sumText = this.i18n.tr('price.sum');

        this.data.query.currentYearColumnTitle = `${currentYear} ${sumText}`;
        this.data.query.previousYearColumnTitle = `${previousYear} ${sumText}`;
    }
}
